const list = {
  path: 'mesTemplet',
  component: resolve => require(['@/pages/admin/platform/message/mesTemplet'], resolve)
}

export default list
